// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__JPZA2","dark":"Navbar_dark__bj3b1","light":"Navbar_light__YEA4i","active":"Navbar_active__l7FQP","link":"Navbar_link__clc6E"};